export function getImageUrl(imageUrl, mobileImageUrl, isMobile) {
  return (isMobile && mobileImageUrl) || imageUrl;
}



// WEBPACK FOOTER //
// ./src/js/helpers/imageUrlHelpers.js